import { IBonusTransaction } from "@/shared/api/bonuses"

export const getOperationType = (transaction: IBonusTransaction) => {
    if (transaction.reason_type === 6) {
        return 'Обмен'
    }
    if (transaction.from.system_id === 'master' && transaction.to.client_id) {
        return 'Начисление'
    }
    if (transaction.from.client_id && transaction.to.client_id) {
        return 'Перевод'
    }
    if (transaction.from.client_id && transaction.to.system_id === 'burn') {
        return 'Списание'
    }
    if (transaction.from.system_id === 'mint' && transaction.to.client_id) {
        return 'Системное Начисление'
    }
    return 'Бонусная Операция'
}